import { CreateStyled } from "@emotion/styled";

// source: https://github.com/emotion-js/emotion/issues/2193#issuecomment-766173118
export const transientOptions: Parameters<CreateStyled>[1] = {
  shouldForwardProp: (propName: string) => !propName.startsWith("$"),
};
